<template lang="html">
  <v-btn :loading="isLoading" @click="syncSkpTriwulan()" outlined class="black ma-2" dark>
    <v-icon>mdi-sync</v-icon> {{ text }}
  </v-btn>
</template>

<script>
import _ from 'lodash'
import store from "@/store"
import SKPService from "@/services/SKPService"

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    triwulan: {
      type: Number,
      required: true,
      validator(value) {
        return [1, 2, 3, 4].includes(value);
      },
    },
    nip: {
      type: String,
      required: true,
    },
    confirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: "Apakah anda yakin ingin melakukan proses ini?"
    },
  },
  data(){
    return {
      isLoading: false
    }
  },
  methods:{
    async syncSkpTriwulan() {
      if (this.confirm && !confirm(this.confirmText)) {
        return;
      }

      this.isLoading = true;
      this.$emit('onSyncStart');

      try {
        const response = await SKPService.syncSakipTriwulanV2(this.nip, this.triwulan);
        this.showSnackbar(response.data.message, "success");
      } catch (err) {
        const message = err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Server sedang sibuk, silahkan coba beberapa saat lagi";
        this.showSnackbar(message, "error");
      } finally {
        this.isLoading = false;
      }
    },

    showSnackbar(message, color) {
      store.commit("snackbar/setSnack", { message, color });
    }
  }
}
</script>
